import LangEnum from '../../../../lang/LangEnum';
import { ColumnsVisibilityConfigItem } from '../ColumnsVisibility/columnsVisibility.types';
import ExpandCollapseButtonGroup from './ExpandCollapseButtonGroup';
import { BuildExpandCollapseViewConfigParams } from './expandCollapseButtonGroup.types';

export const EXPANSION_CONFIG_ID = 'expansion';

export const buildExpandCollapseViewConfig = ({
  label,
  isExpanded,
  defaultValue,
  collapseTestId,
  expandTestId,
  onApply,
}: BuildExpandCollapseViewConfigParams): ColumnsVisibilityConfigItem => ({
  id: EXPANSION_CONFIG_ID,
  label,
  value: isExpanded,
  defaultValue,
  onApply: (value) => onApply(value === true),
  renderControl: ({ onChange }) => (
    <ExpandCollapseButtonGroup
      collapse={{
        label: LangEnum.GLOBAL_COLLAPSE,
        testId: collapseTestId,
        onClick: () => onChange(false),
      }}
      expand={{
        label: LangEnum.GLOBAL_EXPAND,
        testId: expandTestId,
        onClick: () => onChange(true),
      }}
    />
  ),
});
